import type { IFilterObject } from "@/lib/centra/useProductFilter/filterFormatter";

import UI from "./UI";

interface FilterProps {
  filter: IFilterObject;
}

const Filter = ({ filter }: FilterProps) => {
  return <UI filter={filter} />;
};

export default Filter;
